import { render } from "./TwilioViewFullKit.vue?vue&type=template&id=4893d217"
import script from "./TwilioViewFullKit.vue?vue&type=script&lang=js"
export * from "./TwilioViewFullKit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__